import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Spinner } from "../../Components/Spinner/Spinner";
import { AssignedTrack } from "./AssignedTrack";
import NoInfoFound from "../../Components/NoInfoFound/NoInfoFound";

import { callAPI } from "../../assets/Js/backendCommunication";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import projectSettings from "../../assets/Js/projectSettings";
import deleteConfirmationPrompt from "../../assets/Js/deleteConfirmationPrompt";
import { roleEnum } from "../../assets/Js/roleEnum";

const gymHeaders = [
  "Track Name",
  "Status",
  "Trial Days",
  "Price",
  "Type",
  "Action",
];

const athleteHeader = [
  "Track Name",
  "Status",
  "Price",
  "Type",
  "Joinning Date",
];

export const AssignedTracksList = ({
  userId,
  athleteData,
  loggedInUserRole,
  desiredRole,
  isLoading,
}) => {
  const [athleteInfo, setAthleteInfo] = useState([]);

  useEffect(() => {
    setAthleteInfo(athleteData);
  }, [athleteData]);

  const deleteTrackRequest = async (trackId) => {
    let url = `${projectSettings.baseUrl}/tracks/unassign`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;

    let response = "";

    if (response === "") {
    }

    data = {
      trackId,
      userId,
    };

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      apiResponseToast(response.status, "removeTrack", response.data.message);

      if (response.type === "error") {
      } else if (response.type === "success") {
        removeDeletedTrackFromList(trackId);
        response = "";
      }
    }
  };

  const handleDeleteRequest = (trackId) => {
    deleteConfirmationPrompt(deleteTrackRequest, [trackId]);
  };

  const removeDeletedTrackFromList = (trackId) => {
    let _filteredAthleteData = athleteData.filter(
      (eachInfo) => eachInfo.Id !== trackId
    );

    setAthleteInfo(_filteredAthleteData);
  };

  return (
    <div>
      <div className="p-1 pt-3 w-100 dashboardsubSection shadow-sm">
        <div className="h4 ml-3 mt-3 mb-0">Assigned Tracks</div>
        {isLoading ? (
          <Spinner />
        ) : athleteInfo && athleteInfo.length ? (
          <div class="table-responsive p-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  {loggedInUserRole === desiredRole &&
                  desiredRole === roleEnum.athlete
                    ? athleteHeader.map((eachVal) => <th>{eachVal}</th>)
                    : gymHeaders.map((eachVal) => <th>{eachVal}</th>)}
                </tr>
              </thead>
              <tbody className="primaryScrollBar tertiaryScrollBar">
                {athleteInfo.map((currVal, index) => (
                  <AssignedTrack
                    key={index}
                    id={currVal.Id}
                    name={currVal.Name}
                    status={currVal.Status}
                    trialDays={currVal.TrialPeriodDays}
                    price={currVal.Price}
                    type={currVal.Type}
                    joinedOn={currVal.JoinedOn}
                    handleDeleteRequest={
                      loggedInUserRole === roleEnum.owner
                        ? handleDeleteRequest
                        : null
                    }
                  />
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <NoInfoFound className="mt-5" text="No Tracks Joined" />
        )}
      </div>
    </div>
  );
};

AssignedTracksList.propTypes = {
  userId: PropTypes.string,
  athleteData: PropTypes.array,
  loggedInUserRole: PropTypes.string,
  desiredRole: PropTypes.string,
  isLoading: PropTypes.bool,
};
